import { Axios } from 'utils/AxiosConfig'

export const postSubscribeNewsletter = async (payload) => {
  const { data: response } = await Axios.post(`public/newsletter/subscribe`, payload)
  return response
}
